import { DEVICE_HISTORY_FAIL, DEVICE_HISTORY_REQUEST, DEVICE_HISTORY_SUCCESS, DEVICE_LIST_FAIL, DEVICE_LIST_REQUEST, DEVICE_LIST_SUCCESS, DEVICE_LIVE_READING_FAIL, DEVICE_LIVE_READING_REQUEST, DEVICE_LIVE_READING_SUCCESS, DEVICE_READINGS_FAIL, DEVICE_READINGS_REQUEST, DEVICE_READINGS_SUCCESS } from "../constants/liveMonitorConstants"
import { getDeviceList, getLiveDeviceReading, getPowerMeterReadings } from "../services/liveMonitorService"

export const fetchDevices = () => async (dispatch) => {
    try {
        dispatch({
            type: DEVICE_LIST_REQUEST,
        })

        const devices = await getDeviceList();

        dispatch({
            type: DEVICE_LIST_SUCCESS,
            payload: devices,
        })
    } catch (error) {
        dispatch({
            type: DEVICE_LIST_FAIL,
            payload:
                error.response?.data?.message || error.message
        })
    }
}

// Only returns the latest reading for each device
export const fetchLatestReadings = () => async (dispatch) => {
    try {
        dispatch({
            type: DEVICE_READINGS_REQUEST
        });

        const readings = await getPowerMeterReadings();

        const latestReadings = {};

        readings.forEach((reading) => {
            const timestamp = new Date(`${reading.Ddate} ${reading.Dtime}`).getTime();

            const existing = latestReadings[reading.DeviceId];

            if (!existing) {
                latestReadings[reading.DeviceId] = {
                    ...reading,
                    timestamp,
                }
                return;
            }

            if (timestamp > existing.timestamp) {
                latestReadings[reading.DeviceId] = {
                    ...reading,
                    timestamp,
                }
            }
        });

        dispatch({
            type: DEVICE_READINGS_SUCCESS,
            payload: latestReadings,
        });
    } catch (error) {
        dispatch({
            type: DEVICE_READINGS_FAIL,
            payload:
                error.response?.data?.message || error.message,
        })
    }
}

// returns all readings
export const fetchHistoricalReadings = () => async (dispatch) => {
    try {
        dispatch({
            type: DEVICE_HISTORY_REQUEST
        });

        const readings = await getPowerMeterReadings();

        dispatch({
            type: DEVICE_HISTORY_SUCCESS,
            payload: readings
        });
    } catch (error) {
        dispatch({
            type: DEVICE_HISTORY_FAIL,
            payload: error.response?.data?.message || error.message
        })
    }
}

export const fetchLiveDeviceReading = (deviceId) => async (dispatch) => {
    try {
        dispatch({
            type: DEVICE_LIVE_READING_REQUEST,
        });

        const reading = await getLiveDeviceReading(deviceId);

        dispatch({
            type: DEVICE_LIVE_READING_SUCCESS,
            payload: {
                deviceId,
                reading
            }
        });
    } catch (error) {
        dispatch({
            type: DEVICE_LIVE_READING_FAIL,
            payload: 
                error.response?.data?.message ||
                error.message
        })
    }
}